import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VToolbar } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "" } },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c(
                VToolbar,
                { attrs: { dense: "" } },
                [
                  _c("choose-map", {
                    key: _vm.ts,
                    on: { change: _vm.loadSelectedMap },
                    model: {
                      value: _vm.selectedMap,
                      callback: function ($$v) {
                        _vm.selectedMap = $$v
                      },
                      expression: "selectedMap",
                    },
                  }),
                  _c("upload-map", {
                    key: _vm.ts,
                    on: { uploaded: _vm.mapAdded },
                  }),
                  _c(VDivider, {
                    staticClass: "mx-4",
                    attrs: { inset: "", vertical: "" },
                  }),
                  _c(
                    VBtnToggle,
                    {
                      model: {
                        value: _vm.selectMode,
                        callback: function ($$v) {
                          _vm.selectMode = $$v
                        },
                        expression: "selectMode",
                      },
                    },
                    [
                      _c(
                        VBtn,
                        { attrs: { icon: "" } },
                        [_c(VIcon, [_vm._v("mdi-cursor-default-outline")])],
                        1
                      ),
                      _c(
                        VBtn,
                        { attrs: { icon: "" } },
                        [_c(VIcon, [_vm._v("mdi-shape-rectangle-plus")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.selectedMap
                    ? _c(VDivider, {
                        staticClass: "mx-4",
                        attrs: { inset: "", vertical: "" },
                      })
                    : _vm._e(),
                  _vm.selectedMap
                    ? _c(
                        VBtn,
                        {
                          attrs: { icon: "" },
                          on: { click: _vm.deleteSelectedMap },
                        },
                        [_c(VIcon, [_vm._v("mdi-delete-outline")])],
                        1
                      )
                    : _vm._e(),
                  _c(VSpacer),
                  _c(VSwitch, {
                    attrs: {
                      "hide-details": "",
                      flat: "",
                      label: "Show Zones",
                    },
                    model: {
                      value: _vm.showAnnotations,
                      callback: function ($$v) {
                        _vm.showAnnotations = $$v
                      },
                      expression: "showAnnotations",
                    },
                  }),
                ],
                1
              ),
              _c(VDivider),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { attrs: { "no-gutters": "" } },
        [
          _c(
            VCol,
            {
              staticStyle: { "text-align": "center" },
              attrs: { lg: "8", sm: "12" },
            },
            [
              _c("div", { staticClass: "mb-2 text-caption" }, [
                _vm._v("Scale " + _vm._s(_vm._f("formatPercent")(_vm.scale))),
              ]),
              _c(
                "div",
                {
                  ref: "canvasContainer",
                  staticStyle: {
                    position: "relative",
                    border: "1px solid #ccc",
                  },
                  attrs: { tabindex: "1", id: "editzone" },
                  on: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
                          "Backspace",
                          "Delete",
                          "Del",
                        ])
                      )
                        return null
                      return _vm.delAnnotation.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm.selectedMap
                    ? _c(VImg, {
                        key: _vm.ts,
                        attrs: {
                          contain: false,
                          src: _vm.selectedMap.src,
                          width: _vm.selectedMap.mapWidth * _vm.scale,
                          height: _vm.selectedMap.mapHeight * _vm.scale,
                        },
                        on: { load: _vm.setKonvasDimensions },
                      })
                    : _vm._e(),
                  _c(
                    "v-stage",
                    {
                      ref: "stage",
                      staticStyle: {
                        position: "absolute",
                        top: "0",
                        left: "0",
                      },
                      attrs: { config: _vm.configKonva },
                      on: {
                        mousedown: _vm.handleStageMouseDown,
                        touchstart: _vm.handleStageMouseDown,
                        mousemove: _vm.dragMove,
                        mouseup: _vm.handleStageMouseUp,
                        mouseenter: _vm.enterStage,
                        mouseleave: _vm.leaveStage,
                      },
                    },
                    [
                      _vm.showAnnotations
                        ? _c(
                            "v-layer",
                            { ref: "annotationLayer" },
                            [
                              _vm._l(_vm.layerAnnotations, function (rect) {
                                return _c(
                                  "v-group",
                                  {
                                    key: rect.id,
                                    attrs: {
                                      config: {
                                        x: rect.x,
                                        y: rect.y,
                                        draggable: true,
                                      },
                                    },
                                    on: {
                                      transformend: _vm.handleTransformEnd,
                                      dragend: _vm.dragEnd,
                                    },
                                  },
                                  [
                                    _c("v-text", {
                                      attrs: {
                                        config: {
                                          text: rect.name,
                                          x: 10,
                                          y: 10,
                                          fontStyle: "bold",
                                          fontSize: 14,
                                        },
                                      },
                                    }),
                                    _c("v-rect", {
                                      attrs: {
                                        config: {
                                          name: rect.name,
                                          width: rect.width,
                                          height: rect.height,
                                          stroke: rect.rect,
                                          strokeWidth: rect.strokeWidth,
                                          fill: rect.fill,
                                          opacity: rect.opacity,
                                          drawBorder: true,
                                        },
                                      },
                                      on: {
                                        keydown: _vm.delAnnotation,
                                        mouseenter: _vm.enterRect,
                                        mouseleave: _vm.leaveRect,
                                        dblclick: function ($event) {
                                          _vm.assignLocation = null
                                          _vm.showEditAnnotation = true
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              _c("v-transformer", {
                                ref: "transformer",
                                attrs: { config: { rotateEnabled: false } },
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(VCol, { attrs: { lg: "4", sm: "12" } }, [
            _c("div", { staticClass: "ml-5" }, [
              _c("div", { staticClass: "text-center text-caption" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.layerAnnotations ? _vm.layerAnnotations.length : 0
                    ) +
                    " Zones "
                ),
              ]),
              _c(
                "div",
                {
                  style: `height: ${_vm.configKonva.height}px; overflow-y: scroll;`,
                },
                _vm._l(_vm.layerAnnotations, function (annotation) {
                  return _c(
                    VCard,
                    {
                      key: annotation.id,
                      staticClass: "mt-5",
                      attrs: {
                        color:
                          _vm.selectedAnnotationName == annotation.name
                            ? "blue lighten-4"
                            : "",
                      },
                      on: {
                        click: function ($event) {
                          _vm.selectedAnnotationName = annotation.name
                          _vm.updateTransformer()
                        },
                      },
                    },
                    [
                      _c(
                        VCardActions,
                        { staticClass: "justify-end" },
                        [
                          _c(VSpacer),
                          _c(
                            VBtn,
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  _vm.selectedAnnotationName = annotation.name
                                  _vm.assignLocation = null
                                  _vm.showEditAnnotation = true
                                },
                              },
                            },
                            [_c(VIcon, [_vm._v("mdi-circle-edit-outline")])],
                            1
                          ),
                          _c(
                            VBtn,
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  _vm.selectedAnnotationName = annotation.name
                                  _vm.delAnnotation()
                                },
                              },
                            },
                            [_c(VIcon, [_vm._v("mdi-delete-outline")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(VCardTitle, [
                        _vm._v(" " + _vm._s(annotation.name) + " "),
                      ]),
                      _c(
                        VCardSubtitle,
                        { staticClass: "d-flex justify-space-between" },
                        [
                          _c("div", [
                            _vm._v(
                              " width: " +
                                _vm._s(
                                  parseFloat(
                                    annotation.width *
                                      (annotation.scaleX
                                        ? annotation.scaleX
                                        : 1)
                                  ).toFixed(0)
                                ) +
                                " , height: " +
                                _vm._s(
                                  parseFloat(
                                    annotation.height *
                                      (annotation.scaleY
                                        ? annotation.scaleY
                                        : 1)
                                  ).toFixed(0)
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              " x:" +
                                _vm._s(parseFloat(annotation.x).toFixed(0)) +
                                " , y: " +
                                _vm._s(parseFloat(annotation.y).toFixed(0)) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                      _c(VCardText, [
                        _vm._v(
                          "Location " + _vm._s(annotation.locationName) + " "
                        ),
                      ]),
                    ],
                    1
                  )
                }),
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: { width: "450" },
          model: {
            value: _vm.showEditAnnotation,
            callback: function ($$v) {
              _vm.showEditAnnotation = $$v
            },
            expression: "showEditAnnotation",
          },
        },
        [
          _vm.selectedAnnotation
            ? _c(
                VCard,
                { staticClass: "py-10" },
                [
                  _c(VCardTitle, [
                    _vm._v(
                      "Assign location to zone " +
                        _vm._s(_vm.selectedAnnotationName)
                    ),
                  ]),
                  _c(
                    VCardText,
                    [
                      _c(VAutocomplete, {
                        attrs: {
                          items: _vm.locations,
                          label: "Available Locations",
                          "item-text": "name",
                          "item-value": "id",
                          "return-object": "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.assignLocation,
                          callback: function ($$v) {
                            _vm.assignLocation = $$v
                          },
                          expression: "assignLocation",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCardActions,
                    { staticClass: "justify-center" },
                    [
                      _c(VBtn, { on: { click: _vm.updateZoneLocation } }, [
                        _vm._v("Update"),
                      ]),
                      _c(
                        VBtn,
                        {
                          on: {
                            click: function ($event) {
                              _vm.showEditAnnotation = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          !_vm.selectedAnnotation
            ? _c(
                VCard,
                { staticClass: "py-10" },
                [_c(VCardTitle, [_vm._v("No Zone Selected")])],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }